module.exports = __webpack_public_path__ + "static/media/Vue-SDB_08-Manganese-bleu-lagon-2.9d9f7d61.jpg";